import colors from "app/colors";
import { DistributionGroupFragment } from "gql/graphql";
import { CALLOUT_KEY } from "modules/utils/Constants";
import { highlightText } from "./quill-highlight-text";

export const renderQuillDistributionGroupMention = (
  distributionGroup: DistributionGroupFragment,
  searchTerm: string,
) => {
  const color = colors.blue;
  const callout = `${CALLOUT_KEY}${distributionGroup.name}`;

  const wrapper = document.createElement("div");
  wrapper.style.display = "flex";
  wrapper.style.alignItems = "center";
  wrapper.style.gap = "8px";

  const icon = document.createElement("div");
  icon.innerHTML = `
    <svg width="32px" height="32px" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="#CCE4FF" />
      <path d="M20.7999 17.0667C19.5199 17.0667 17.5253 17.4293 15.9999 18.1333C14.4746 17.4187 12.4799 17.0667 11.1999 17.0667C8.88527 17.0667 4.2666 18.2187 4.2666 20.5333V23.4667H27.7333V20.5333C27.7333 18.2187 23.1146 17.0667 20.7999 17.0667ZM16.5333 21.8667H5.8666V20.5333C5.8666 19.9573 8.59727 18.6667 11.1999 18.6667C13.8026 18.6667 16.5333 19.9573 16.5333 20.5333V21.8667ZM26.1333 21.8667H18.1333V20.5333C18.1333 20.0427 17.9199 19.616 17.5786 19.232C18.5173 18.912 19.6693 18.6667 20.7999 18.6667C23.4026 18.6667 26.1333 19.9573 26.1333 20.5333V21.8667ZM11.1999 16C13.2586 16 14.9333 14.3253 14.9333 12.2667C14.9333 10.208 13.2586 8.53333 11.1999 8.53333C9.14127 8.53333 7.4666 10.208 7.4666 12.2667C7.4666 14.3253 9.14127 16 11.1999 16ZM11.1999 10.1333C12.3733 10.1333 13.3333 11.0933 13.3333 12.2667C13.3333 13.44 12.3733 14.4 11.1999 14.4C10.0266 14.4 9.0666 13.44 9.0666 12.2667C9.0666 11.0933 10.0266 10.1333 11.1999 10.1333ZM20.7999 16C22.8586 16 24.5333 14.3253 24.5333 12.2667C24.5333 10.208 22.8586 8.53333 20.7999 8.53333C18.7413 8.53333 17.0666 10.208 17.0666 12.2667C17.0666 14.3253 18.7413 16 20.7999 16ZM20.7999 10.1333C21.9733 10.1333 22.9333 11.0933 22.9333 12.2667C22.9333 13.44 21.9733 14.4 20.7999 14.4C19.6266 14.4 18.6666 13.44 18.6666 12.2667C18.6666 11.0933 19.6266 10.1333 20.7999 10.1333Z" fill=${colors.blue} />
    </svg>
  `;
  icon.style.flexShrink = "0";
  icon.style.display = "flex";
  icon.style.alignItems = "center";

  wrapper.appendChild(icon);

  const textElement = highlightText(callout, searchTerm);
  textElement.style.fontStyle = distributionGroup.active ? "normal" : "italic";
  textElement.style.color = color;
  textElement.style.fontWeight = "500";
  textElement.style.fontSize = "14px";
  textElement.style.opacity = distributionGroup.active ? "1" : "0.6";

  wrapper.appendChild(textElement);

  return wrapper;
};
